import throttle from "lodash/throttle";

export const getOptionsFn = (apiFn) => {
  return (like, callback) => {
    apiFn({ count: 10, filterConfig: { like } })
      .then(results => {
        const options = results.edges.map(edge => ({
          key: edge.cursor,
          value: edge.node.id,
          label: edge.node.name
        }))
        callback(options, options)
      })
      .catch(err => {
        callback(err)
      })
  }
}

export const getThrottledOptionsFn = (apiFn) => {
  return throttle(getOptionsFn(apiFn), 250, { tailing: true })
}

export const canRetryJob = ({ job }) => {
  const { status, retriable } = job

  return (status === 'FAILED' || status === 'DUPLICATE' || status === 'CANCELLED') && retriable
}

export const canFailJob = ({ job }) => {  
  return job.status === 'PROCESSING'
    && ((new Date().getTime() - job.creationTimestamp) / 1000) > 30 * 60 // 30 min*/
}